import axios from "axios";
import store from "../redux/store";
import { setTokens, logOut } from "../redux/slices/authSlice";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL_APP || "http://localhost:3000/api";

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// --- RESPONSE INTERCEPTOR FOR TOKEN REFRESH ---
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return api(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }
      originalRequest._retry = true;
      isRefreshing = true;
      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken) {
        store.dispatch(logOut());
        return Promise.reject(error);
      }
      try {
        const res = await axios.post(
          (process.env.REACT_APP_API_BASE_URL_APP ||
            "http://localhost:3000/api") + "/auth/refresh-token",
          { refreshToken },
          { headers: { "Content-Type": "application/json" } }
        );
        const { access, refresh } = res.data.data;
        store.dispatch(
          setTokens({ accessToken: access.token, refreshToken: refresh.token })
        );
        localStorage.setItem("accessToken", access.token);
        localStorage.setItem("refreshToken", refresh.token);
        api.defaults.headers.common["Authorization"] = "Bearer " + access.token;
        processQueue(null, access.token);
        originalRequest.headers["Authorization"] = "Bearer " + access.token;
        return api(originalRequest);
      } catch (err) {
        processQueue(err, null);
        store.dispatch(logOut());
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);
